<div class="play-list-action-bar">
    <r1-compass-lib-breadcrumb-list [breadcrumbList]="breadcrumbs()" (noBreadcrumbsBackupEvent)="goToRoot()" />
    <button mat-raised-button [matMenuTriggerFor]="menu" color="primary" type="button">+ New</button>
    <mat-menu #menu="matMenu">
        <button mat-menu-item [matMenuTriggerFor]="generatorTypeMenu" type="button">Play</button>
        <mat-menu #generatorTypeMenu="matMenu">
            <button mat-menu-item (click)="onCreatePlay('Builder')" type="button">Builder</button>
            <button mat-menu-item (click)="onCreatePlay('Importer')" type="button">Importer</button>
        </mat-menu>
        <button mat-menu-item (click)="onCreateFolder()" type="button">Folder</button>
    </mat-menu>
</div>

<r1-compass-lib-file-table
    [columns]="columns"
    [fileTableData]="sortedFileTableEntries()"
    [searchedFilesAndFolders]="searchContent()"
    (folderChange)="onChangeFolder($event)"
    (editAsset)="onEditAsset($event)"
    (clickOption)="onOptionClicked($event)"
    (searchFilesAndFolders)="onTypeaheadSearch($event)" />
